import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import PricingTableList from '../PricingTable/PricingTableList'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Service Details');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading 
        title='Service Details'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={params.serviceDetailsId}
      />

      <Spacing lg='150' md='50'/>
      {params.serviceDetailsId === 'ui-ux-design'?
        <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src="/images/service_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
            </Div>
            <Spacing lg='0' md='40'/>
          </Div>
          
          <Div className="col-lg-6 offset-xl-1">
            <Spacing lg='50' md='30'/>
            <Div className="row">
              <Div>
                <h2 className="cs-font_50 cs-m0">Design With Femto</h2>
                <Spacing lg='20' md='10'/>
                <p>
                  Investing in clean, modern website design is the key to unlocking your online potential and captivating your target audience.<br></br><br></br>
                  By adopting a visually appealing and user-friendly design, you create an intuitive and engaging experience that keeps visitors on your site longer, increasing the likelihood of conversions.<br></br><br></br>
                  A well-crafted, contemporary design not only enhances your brand's image but also improves website performance and accessibility across devices, ensuring your content reaches the widest possible audience.<br></br><br></br>
                  Elevate your online presence with a clean, modern website design, and watch your business thrive as you make a lasting impression on your visitors.
                </p>
              </Div>  
              <Div className="col-lg-6">
                <Button btnText='Website design' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='Social media design' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
              <Div className="col-lg-6">
                <Button btnText='Ad banner design' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='Other custom designs' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>:params.serviceDetailsId === 'reactjs-development'?
        <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src="/images/service_2.jpeg" alt="Service" className='cs-radius_15 w-100' />
            </Div>
            <Spacing lg='0' md='40'/>
          </Div>
          
          <Div className="col-lg-6 offset-xl-1">
            <Spacing lg='50' md='30'/>
            <Div className="row">
              <Div>
                <h2 className="cs-font_50 cs-m0">React.js With Femto</h2>
                <Spacing lg='20' md='10'/>
                <p>
                  Embrace the potential of React.js for your website and web app development projects. <br></br><br></br>
                  This popular JavaScript library, created and maintained by Facebook, offers unparalleled efficiency and flexibility to build responsive, interactive, and scalable user interfaces.<br></br><br></br>
                  With React.js, you'll benefit from a rich ecosystem of tools and libraries, enabling faster development, improved performance, and enhanced maintainability.<br></br><br></br>
                  Opt for React.js and invest in a future-proof solution that delivers exceptional user experiences and drives your online success.<br></br><br></br>
                </p>
              </Div>  
              <Div className="col-lg-6">
                <Button btnText='Business showcase website' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='eCommerce websites' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
              <Div className="col-lg-6">
                <Button btnText='Cross-platform applications' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='Other software solutions' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
            </Div>
          </Div>
          <Spacing lg='50' md='30'/>
        </Div>
      </Div>:params.serviceDetailsId === 'web-hosting'?
        <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src="/images/web-hosting.jpg" alt="Service" className='cs-radius_15 w-100' />
            </Div>
            <Spacing lg='0' md='40'/>
          </Div>
          
          <Div className="col-lg-6 offset-xl-1">
            <Spacing lg='50' md='30'/>
            <Div className="row">
            <Div>
              <h2 className="cs-font_50 cs-m0">Web Hosting With Femto</h2>
              <Spacing lg='20' md='10'/>
              <p>
                Partnering with a reliable web hosting company is essential for ensuring your website's optimal performance, security, and accessibility.<br></br><br></br>
                By entrusting your online presence to a Femto, you'll enjoy the benefits of lightning-fast load times, robust uptime guarantees, and comprehensive security measures.<br></br><br></br>
                This means your visitors will experience seamless, uninterrupted access to your site, boosting user satisfaction and increasing conversions.<br></br><br></br>
                Additionally, a dependable web hosting company offers exceptional customer support, providing prompt assistance and expert guidance to keep your website running smoothly.
              </p>
            </Div>  
              <Div className="col-lg-6">
                <Button btnText='Host any website' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='Domain registration' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
              <Div className="col-lg-6">
                <Button btnText='Secure servers with 99% uptime' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
                <Button btnText='24/7 client support' variant='cs-type2'/>
                <Spacing lg='20' md='10'/>
              </Div>
            </Div>
          </Div>
        </Div>
        <Spacing lg='20' md='10'/>
        <Div className="container">
        <Spacing lg='50' md='30'/>
        <SectionHeading
          title='Our Hosting Packages'
          subtitle='Pricing & Packaging'
        />
        <Spacing lg='85' md='40' />
        <PricingTableList />
      </Div>
      </Div>:
      params.serviceDetailsId === 'backend-development'?
      <Div className="container">
      <Div className="row align-items-center">
        <Div className="col-xl-5 col-lg-6">
          <Div className="cs-radius_15 cs-shine_hover_1">
            <img src="/images/backend.jpg" alt="Service" className='cs-radius_15 w-100' />
          </Div>
          <Spacing lg='0' md='40'/>
        </Div>
        
        <Div className="col-lg-6 offset-xl-1">
          <Div className="row">
            <Div>
              <h2 className="cs-font_50 cs-m0">Backend Development With Femto</h2>
              <Spacing lg='20' md='10'/>
              <p>
                Elevate your backend development with Python, the dynamic and versatile programming language trusted by industry leaders.<br></br><br></br>
                By harnessing Python's power for creating and managing custom APIs and databases, you'll enjoy streamlined development, robust performance, and unparalleled scalability.<br></br><br></br>
                Python's extensive library support and easy-to-read syntax empower developers to build powerful, secure, and adaptable backend solutions that can effortlessly handle the most complex data and logic requirements.<br></br><br></br>
                Choose Python for your backend development and unleash your project's full potential, delivering a truly extraordinary digital experience that sets you apart from the competition.
              </p>
            </Div>  
            <Div className="col-lg-6">
              <Button btnText='Python Backend Development' variant='cs-type2'/>
              <Spacing lg='20' md='10'/>
              <Button btnText='Custom API Development' variant='cs-type2'/>
              <Spacing lg='20' md='10'/>
            </Div>
            <Div className="col-lg-6">
              <Button btnText='Server Resource Optimization' variant='cs-type2'/>
              <Spacing lg='20' md='10'/>
              <Button btnText='Custom Database Solutions' variant='cs-type2'/>
              <Spacing lg='20' md='10'/>
            </Div>
          </Div>
        </Div>
      </Div>
    </Div>:''
       }
      <Spacing lg='150' md='80'/>
      {/* <TestimonialSlider /> */}
      {/* <Spacing lg='145' md='80'/>
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-5 col-lg-6">
              <SectionHeading
                title='Some pre questions and answers' 
                subtitle='FAQ’s'
              />
              <Spacing lg='90' md='45'/>
            </Div>
            <Div className="col-lg-6 offset-xl-1">
              <Accordion/>
            </Div>
          </Div>
        </Div>
      </Div> */}
      <Spacing lg='50' md='80'/>
      <Div className="container">
        <Cta 
          title="Let’s talk and make <br/> something <i> amazing </i> together"
          btnText="Contact Us"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  )
}
